import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { uploadStatementPdf } from "../../helpers/api"; // Import your API function

const StatementAnalyzer: React.FC = () => {
  const [uploading, setUploading] = useState(false);
  const [downloadData, setDownloadData] = useState<{
    url: string;
    fileName: string;
  } | null>(null);
  const [error, setError] = useState<string | null>(null);

  const onDrop = useCallback(async (acceptedFiles: File[]) => {
    setError(null);
    setDownloadData(null);
    if (acceptedFiles.length === 0) return;
    setUploading(true);
    try {
      const file = acceptedFiles[0];
      const { resultBlob, fileName } = await uploadStatementPdf(file);
      const url = window.URL.createObjectURL(resultBlob);
      setDownloadData({ url, fileName });
    } catch (err) {
      setError((err as any).message || "Upload failed");
    } finally {
      setUploading(false);
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "application/pdf": [".pdf"] },
    multiple: false,
  });

  return (
    <div>
      <div
        {...getRootProps()}
        style={{
          border: "2px dashed #888",
          padding: 32,
          textAlign: "center",
          borderRadius: 8,
          background: isDragActive ? "#f0f0f0" : "#fff",
          cursor: "pointer",
        }}
      >
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Drop the PDF here...</p>
        ) : (
          <p>Drag & drop a PDF file here, or click to select one</p>
        )}
      </div>
      {uploading && <p>Uploading...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
      {downloadData && (
        <a
          href={downloadData.url}
          download={downloadData.fileName}
          style={{ display: "block", marginTop: 16 }}
        >
          Download Analyzed Statement CSV
        </a>
      )}
    </div>
  );
};

export default StatementAnalyzer;
